"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const getValueByPathFromUnknown_1 = __importDefault(require("../../shared/getValueByPathFromUnknown"));
const valueIsNullOrUndef_1 = __importDefault(require("../../typeAssertions/valueIsNullOrUndef"));
const appStateSelectLocalStorageData_1 = __importDefault(require("../../shared/appStateSelectLocalStorageData"));
const General_1 = require("../../types/General");
const cleanDatabasePath_1 = __importDefault(require("../../FirebaseDatabaseCache/cleanDatabasePath"));
const firebaseIsPathValid_1 = __importDefault(require("../../shared/firebaseIsPathValid"));
const callableLocalStorageDbGetDirect = async ({ store, functionId, entryVars, callbacks, executeProcesses, }) => {
    const executeError = (error) => {
        executeProcesses(functionId, callbacks[General_1.DEFINITION_PROP_NAMES.CATCH], error);
    };
    const path = entryVars[General_1.DEFINITION_PROP_NAMES.PATH];
    if (!(0, ts_validators_1.valueIsString)(path)) {
        executeError('Path must to be an string');
        return;
    }
    const validPathMessageError = (0, firebaseIsPathValid_1.default)(path);
    if (validPathMessageError) {
        executeError(validPathMessageError);
        return;
    }
    const localStorageData = (0, appStateSelectLocalStorageData_1.default)(store.getState());
    const data = (0, getValueByPathFromUnknown_1.default)(localStorageData, (0, cleanDatabasePath_1.default)(path).split('/'));
    if ((0, valueIsNullOrUndef_1.default)(data)) {
        executeError('Data not found');
        return;
    }
    executeProcesses(functionId, callbacks[General_1.DEFINITION_PROP_NAMES.THEN], data);
};
exports.default = callableLocalStorageDbGetDirect;
